// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YeA56{display:flex;flex-direction:column;gap:16px;width:100%;max-width:600px;margin:0 auto}.TnAxh{display:flex;flex-direction:column;gap:12px;padding-bottom:16px}.QtKfz{display:flex;gap:12px}.yHQ3R{display:flex;gap:12px}.zXv0v{flex:1}.QPKAp{display:flex;justify-content:flex-end}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `YeA56`,
	"memberRow": `TnAxh`,
	"nameRow": `QtKfz`,
	"contactRow": `yHQ3R`,
	"field": `zXv0v`,
	"removeButton": `QPKAp`
};
export default ___CSS_LOADER_EXPORT___;
